import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-weblink-loader',
  templateUrl: './weblink-loader.component.html',
  styleUrls: ['./weblink-loader.component.css']
})
export class WeblinkLoaderComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
